import React, { useState } from "react";
import { buildApiUrl } from '../config/api';

const Newsletter = () => {
    const [email, setEmail] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;

        setIsLoading(true);

        try {
            const response = await fetch(buildApiUrl('api/newsletter/subscribe'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setIsSubscribed(true);
                setEmail('');
            } else {
                // Handle specific error cases
                if (response.status === 409) {
                    alert('This email is already subscribed to our newsletter!');
                } else if (response.status === 400) {
                    alert(data.error || 'Please enter a valid email address.');
                } else {
                    alert('There was an error subscribing. Please try again.');
                }
            }
        } catch (error) {
            console.error('Error subscribing to newsletter:', error);
            alert('There was an error subscribing. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="newsletter-section">
            <div className="newsletter-content">
                <h2>Don’t miss a Meow!</h2>
                <p>
                    Subscribe to my newsletter to hear when new products hit the database,
                    get sneak peeks at upcoming features, and see what I'm building to make your life (and your cat's meals) a little easier.
                </p>

                {!isSubscribed ? (
                    <form onSubmit={handleSubscribe} className="newsletter-form">
                        <div className="form-group">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email address"
                                required
                                className="newsletter-input"
                            />
                            <button
                                type="submit"
                                className="newsletter-button"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Subscribing...' : 'Subscribe'}
                            </button>
                        </div>
                    </form>
                ) : (
                    <div className="success-message">
                        <p>You’ll be the first to hear about new products, features, and updates, straight to your inbox.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Newsletter; 